export default function ({ $auth, redirect, route }) {
  if ($auth.loggedIn) {
    const redirectLink = route.query.redirect_from || '/'
    return redirect(redirectLink)
  }
}
